<template>
  <section class="hero is-white">
    <div class="hero-body">
      <div class="container">
        <div class="breadcrumb-wrapper">
          <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
          <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/index">Trang chủ</router-link></li>
              <li class="is-active"><a>Thông tin tài khoản</a></li>
            </ul>
          </nav>
        </div>
      </div>
      <h2 class="title-profile">Thông tin tài khoản</h2>
      <div class="container container--profile">
        <div class="columns is-mobile is-multiline" v-if="profile && !isLoadingPage">
          <div class="column is-half is-size-4 th">Công ty</div>
          <div class="column is-half is-size-4">{{profile.company}}</div>

          <div class="column is-half is-size-4 th">Tài khoản</div>
          <div class="column is-half is-size-4">{{profile.username}}</div>

          <div class="column is-half is-size-4 th">Mật khẩu</div>
          <div class="column is-half is-size-4">
            <b-button type="is-info" @click="openUpdatePassModal">Thay đổi</b-button>
          </div>

          <div class="column is-half is-size-4 th">Loại tài khoản</div>
          <div class="column is-half is-size-4">{{getAccountType(profile.level)}}</div>

          <div class="column is-half is-size-4 th">
            Số lượng kết nối
            <br>hiện tại
          </div>
          <div class="column is-half is-size-4">
            {{profile.limit}} &nbsp;&nbsp;&nbsp;
            <!-- <router-link :to="'/contact'">Nâng cấp</router-link> -->
          </div>

          <div class="column is-half is-size-4 th">Thời gian sử dụng</div>
          <div class="column is-half is-size-4">{{getDuration(profile.level)}} ngày</div>

          <div class="column is-half is-size-4 th">Bắt đầu</div>
          <div class="column is-half is-size-4">{{getFormatDate(profile.startAt)}}</div>

          <div class="column is-half is-size-4 th last">Thời gian còn lại</div>
          <div
            class="column is-half is-size-4 last"
          >{{getRemaining(profile.startAt, profile.level)}} ngày</div>
        </div>
        <div class="columns is-mobile is-multiline" v-if="isLoadingPage">
          <div class="column is-half is-size-4">
            <skeleton-box></skeleton-box>
          </div>
          <div class="column is-half is-size-4">
            <skeleton-box></skeleton-box>
          </div>
          <div class="column is-half is-size-4 last">
            <skeleton-box></skeleton-box>
          </div>
          <div class="column is-half is-size-4 last">
            <skeleton-box></skeleton-box>
          </div>
        </div>

        <b-modal :active.sync="isOpenUpdatePassModal">
          <div class="content-layout content-layout--passcode">
            <header class="modal-card-head"><p class="modal-card-title">Đổi mật khẩu</p><button aria-label="close" class="delete" @click="isOpenUpdatePassModal=false"></button></header>
            <form @submit.prevent="validatePassword">
            <div class="content-layout__inner">
               <div class="form-user">
                <b-field
                  :type="{'is-danger': errors.has('current-password')}"
                  :message="errors.first('current-password')"
                  custom-class="has-text-weight-normal body-text"
                >
                  <template slot="label">
                    Mật khẩu hiện tại <span class="has-text-danger">*</span>
                  </template>
                  <b-input
                    v-model="currentPassword"
                    type="password"
                    name="current-password"
                    v-validate="{required: true, regex: /\w/}"
                    size="is-medium"
                    ref="password"
                    data-vv-as="Mật khẩu hiện tại"
                  ></b-input>
                </b-field>

                <b-field
                  :type="{'is-danger': errors.has('new-password')}"
                  :message="errors.first('new-password')"
                  custom-class="has-text-weight-normal body-text"
                >
                  <template slot="label">
                    Mật khẩu mới <span class="has-text-danger">*</span>
                  </template>
                  <b-input
                    v-model="newPassword"
                    type="password"
                    name="new-password"
                    v-validate="{required: true, regex: /\w/, min: 8}"
                    size="is-medium"
                    data-vv-as="Mật khẩu mới"
                  ></b-input>
                </b-field>

                <b-field
                  :type="{'is-danger': errors.has('confirm-new-password')}"
                  :message="errors.first('confirm-new-password')"
                  custom-class="has-text-weight-normal body-text"
                >
                  <template slot="label">
                    Xác nhận mật khẩu <span class="has-text-danger">*</span>
                  </template>
                  <b-input
                    v-model="confirmNewPassword"
                    v-validate="{ required: true, is: newPassword }"
                    type="password"
                    name="confirm-new-password"
                    size="is-medium"
                    data-vv-as="Xác nhận mật khẩu"
                  ></b-input>
                </b-field>
              </div>
            </div>
            <div class="modal-bottom-group field is-grouped is-grouped-centered">
              <div class="control">
                <b-button @click="isOpenUpdatePassModal=false">Đóng</b-button>
              </div>
              <div class="control">
                <b-button type="is-info" native-type="submit">Cập nhật</b-button>
              </div>
            </div>
            </form>
          </div>
        </b-modal>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";

import Utils from "../components/shared/Utils";

export default {
  components: {
    SkeletonBox: () => import("../components/shared/Skeleton")
  },
  data() {
    return {
      isLoadingPage: false,
      isOpenUpdatePassModal: false,
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: ""
    };
  },
  created() {
    this.isLoadingPage = true;
    this.getProfile().finally(() => (this.isLoadingPage = false));
  },
  methods: {
    ...mapActions("auth", ["getProfile", "changePasswordUserDMA"]),
    getAccountType: Utils.getAccountType,
    getFormatDate: Utils.getFormatDate,
    getDuration(level) {
      let duration = 0;
      switch (level) {
        case 1:
          duration = 30;
          break;
        case 2:
          duration = 360;
          break;
      }
      return duration;
    },

    getRemaining(dateStr, level) {
      let duration;
      switch (level) {
        case 1:
          duration = 30;
          break;
        case 2:
          duration = 360;
          break;
      }
      const startAt = new Date(dateStr);
      const dateNow = new Date();
      const timeDiff = Math.abs(dateNow.getTime() - startAt.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return duration - diffDays;
    },

    validatePassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.updatePassWord();
        }
      });
    },
    updatePassWord() {
      const password = this.newPassword;
      const { username, firstName, lastName } = this.profile;
      this.changePasswordUserDMA({
        user: { username, firstName, lastName, password },
        oldPass: this.currentPassword
      }).then(res => {
        if (res.data.status) {
          const message = "Cập nhật mật khẩu của bạn thành công!!";
          this.isOpenUpdatePassModal = false;
          this.$toast.open({
            message,
            type: "is-info"
          });
        } else {
          this.$toast.open({
            message: res.data.message,
            type: "is-info"
          });
        }
      });
    },
    openUpdatePassModal() {
      this.isOpenUpdatePassModal = true
      this.$nextTick(() => {
        this.$refs.password.$el.querySelector('input').focus()
      })
    }
  },
  computed: {
    ...mapState("auth", ["profile"])
  }
};
</script>

<style lang="scss" scoped>
.hero {
  padding-top: 0;
}
.container {
  &--profile {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
}
.title-profile {
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2rem;
}
.hero-body {
  padding-top: 2rem;
}
.column.is-half {
  border-bottom: 1px solid #cecece;
  &.last {
    border-bottom: none;
  }
}
</style>
